import { render } from "./PosTransaction.vue?vue&type=template&id=caf7c59c&scoped=true"
import script from "./PosTransaction.vue?vue&type=script&lang=js"
export * from "./PosTransaction.vue?vue&type=script&lang=js"

import "@/assets/css/user/common.css?vue&type=style&index=0&id=caf7c59c&scoped=true&lang=css"
import "@/assets/css/user/dark/common-dark.css?vue&type=style&index=1&id=caf7c59c&scoped=true&lang=css"
import "./PosTransaction.vue?vue&type=style&index=2&id=caf7c59c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shcho\\Desktop\\home\\git\\test\\cloudpos.kiosk\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-caf7c59c"]])

export default __exports__